import styles from "./Logo.module.scss";

import MyleBrandingLogoEn from "./Types/myle-branding-logo-en.svg";
import MyleBrandingLogoEs from "./Types/myle-branding-logo-es.svg";
import MyleBrandingLogoFr from "./Types/myle-branding-logo-fr.svg";

/**
 * The size of the logo to render.
 */
type LogoSize = "md";

/**
 * The type of logo to render.
 */
type LogoType = "myle-emr-logo";

/**
 * The language of logo to render.
 */
type Language = "en" | "fr" | "es";

interface ILogoProps {
    /**
     * The optional button ID.
     */
    id?: string;

    /**
     * An ID to target in frontend tests.
     */
    dataCy?: string;

    /**
     * The size of the logo.
     */
    size?: LogoSize;

    /**
     * The language of logo to render.
     */
    language?: Language;

    /**
     * The type of logo to render;
     */
    type?: LogoType;
}

const logoMap = {
    ["myle-emr-logo"]: {
        default: MyleBrandingLogoEn,
        en: MyleBrandingLogoEn,
        es: MyleBrandingLogoEs,
        fr: MyleBrandingLogoFr
    }
};

function Logo({ id, dataCy, size = "md", language = "en", type = "myle-emr-logo" }: Readonly<ILogoProps>): JSX.Element {
    const LogoSvg = logoMap[type][language] ?? logoMap[type]["default"];

    return (
        <div
            id={id}
            data-cy={dataCy}
            className={`${styles.logo} ${styles[type]} ${styles[size]}`}
        >
            <LogoSvg />
        </div>
    );
}

export { Logo };
